import { Grid } from '@material-ui/core';
import { CircleLoader, PageHeader } from 'components';
import React from 'react';

interface IPageProps {
    isLoading: boolean
    useHeader: boolean
    title: React.ReactNode | string
    subtitle?: React.ReactNode | string
    addNewUrl?: string
    children: React.ReactNode
}

let Page = ({ isLoading, useHeader, children, ...rest }: IPageProps) => {
    return (
        <Grid container spacing={1}>
            {useHeader &&
                <Grid item xs={12}>
                    <PageHeader {...rest} />
                </Grid>
            }
            <Grid item xs>
                {isLoading === true && <CircleLoader />}
                {isLoading === false && children}
            </Grid>
        </Grid>
    );
};


export default Page;
